export const getIndexArray = (length = 0) =>
  Array.from({ length }, (_value, index) => index);
